export interface PassChangeReason {
	Id: number | null;
	Name: string;
	Description: string;
	Active: boolean;
}

export const PASS_CHANGE_REASON_INITIAL_VALUES: PassChangeReason = {
	Id: null,
	Name: "",
	Description: "",
	Active: true,
};
